import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import ptbr from 'locales/ptbr/translation.json';
import en from 'locales/en/translation.json';

const resources = {
  en: {
    translation: en,
  },
  ptbr: {
    translation: ptbr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ptbr',
    fallbackLng: 'ptbr',

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
